import { Directive, InjectionToken } from '@angular/core';

export const AD_PREFIX: any = new InjectionToken<AtPrefix>('atPrefix')

@Directive({
  selector: '[atPrefix]',
  providers: [{provide: AD_PREFIX, useExisting: AtPrefix}]
})
export class AtPrefix {}
